import React, { useState } from 'react';
import { CcIcon } from '@utp/components-react';
import styled from 'styled-components';
import OutsideClickHandler from 'react-outside-click-handler';
import IDHelpers from '../../core/helpers/IDHelper';
import UserBlankImageUrl from '../../assets/images/no-user-image.svg';

interface IMenuList {
  labelText?: string;
  iconName?: string;
  modeClick: boolean;
  handleClick?: () => void;
  urlClick?: string;
}

interface IUserData {
  userName?: string;
  userAvatar?: string;
}

interface Props {
  menu?: Array<IMenuList> | null;
  user?: Array<IUserData> | null;
  loadingClearCache: boolean;
  loginAction: () => void;
}

const UserMenuWrapper = styled.div`
  text-align: center;
  color: var(--neutral-03);
  display: inline-flex;
  font-size: 16px;
`;

const UserMenuElement = styled(UserMenuWrapper)`
  display: flex;
  grid-gap: 24px;
  align-items: center;
  .usermenu {
    color: white;
  }
  .usermenu .button.sc-cc-button {
    background-color: #b0c0ca;
  }

  .border-b {
    min-height: 90px;
  }

  .usermenu > * > .flex {
    display: block;
    float: right;
  }

  .relative {
    position: relative;
  }

  .shadow {
    box-shadow: 0 4px 16px -8px #b0c0ca;
  }

  .overflow-hidden {
    overflow: hidden;
  }

  .rounded-sm {
    border-radius: 0.4rem;
  }

  .bg-neutral-04 {
    background-color: var(--neutral-04);
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .py-xlg {
    border-color: var(--background-01);
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .mt-sm {
    margin-top: 0.8rem;
  }
  .text-body {
    min-width: 20.8rem;
    width: 100%;
    display: block;
  }

  .user__element {
    display: flex;
    align-items: center;
  }
  .user__element cc-icon {
    color: white;
  }
  .user__element-label {
    line-height: 48px;
    text-transform: capitalize;
  }
  .user__element-avatar {
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 50%;
  }

  .user__element-avatar:hover {
    background-color: var(--primary-hover);
  }

  .user__element-avatar:focus {
    background-color: var(--primary-hover);
  }

  .user__element-avatar:active {
    background-color: var(--primary-active);
  }

  .user__element-icon {
    color: var(--text-text02);
    height: 24px;
    display: table-cell;
    vertical-align: middle;
  }
  .user__element-toggle {
    display: table;
    height: 48px;
    outline: none;
    padding: 12px 0px;
  }

  .usermenu__toggle-menu {
    width: 137px;
    position: absolute;
    top: 68px;
    right: 0px;
    display: none;
    z-index: 99;
  }

  .usermenu__toggle-user {
    position: relative;
    padding: 0px 0px 0px 15px;
    outline: none;
  }

  .usermenu__toggle-user:focus {
    outline: none;
  }

  .menu__element-label {
    line-height: 40px;
    display: block;
    float: left;
    color: var(--text-text02);
  }

  .menu__element-link {
    line-height: 40px;
    display: flex;
    flex-flow: row;
    width: 100%;
    color: var(--text-text01);
  }

  .menu__element-link:hover {
    color: var(--text-text02);
    background-color: var(--primary-disable-background);
  }
  .menu__element-link:active,
  .menu__element-link:focus {
    background-color: var(--card-focus);
  }

  .menu__element-link cc-icon {
    display: flex;
    align-items: center;
    align-content: center;
    color: var(--neutrals-neutral01);
  }
  .menu__element-link:hover cc-icon {
    color: var(--neutrals-neutral02);
  }
  .usermenu__toggle--active .usermenu__toggle-menu {
    display: block;
  }

  .menu__element-icon {
    display: block;
    height: 40px;
    padding: 4px 0px 4px;
    float: left;
  }

  .usermenu__toggle-menu-container {
    padding: 8px 0px;
    display: block;
    float: left;
  }

  .menu__container_element {
    display: flex;
    margin-left: 10px;
  }

  .btn-focus {
    border: 2px solid #fff;
    border-radius: 50%;
    width: 40px;
    height: auto;
    align-items: center;
    display: flex;
  }

  .btn-focus: hover {
    border: 2px solid #745ef6;
  }
  .btn-focus: focus {
    outline: 0;
    border: 2px solid #745ef6;
  }
  .btn-focus: active {
    outline: 0;
    border: 2px solid #4318cd;
  }

  @media (max-width: 768px) {
    .user__element-label {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-transform: capitalize;
    }
    .usermenu__toggle-menu {
      top: 57px;
    }
  }

  .image_rotate {
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(359deg);
    }
    to {
      transform: rotate(0deg);
    }
  }
`;

const ContainerHelp = styled.div`
  display: flex;
  grid-gap: 24px;
  align-items: center;
`;

const Button = styled.a`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
  border-radius: 4px;
  padding: 8px 12px;
  &:hover {
    outline: 1px solid #fff;
  }
`;

const UserBlankImage = styled.img`
  position: static;
  width: 40px;
  height: 40px;
  left: 91px;
  top: 0px;
`;

function UserMenuHelp(props: Props) {
  const { menu, user, loadingClearCache, loginAction } = props;
  const menuList = menu;
  const userData = user;
  const [openmenu, setOpenmenu] = useState(false);

  const menuToggle = () => {
    setOpenmenu(!openmenu);
  };
  const openMenuToggleActive = () =>
    openmenu ? 'usermenu__toggle--active' : '';

  return (
    <UserMenuElement>
      <UserMenuWrapper>
        {
          /* credentials && isValidToken */ menuList ? (
            <div className="usermenu">
              <div>
                <div
                  className={`flex ml-auto usermenu__toggle ${openMenuToggleActive()}`}
                >
                  <div role="menu" className="usermenu__toggle-user">
                    {userData &&
                      // userData[0].userName !== undefined &&
                      userData.map((usercontent: any) => (
                        <div
                          className="user__element"
                          key={IDHelpers.generateID()}
                        >
                          <span className="user__element-label">
                            ¡Hola, <b>{usercontent.userName.split(' ')[0]}!</b>
                          </span>
                          <div
                            className="btn-focus"
                            role="button"
                            tabIndex={0}
                            onClick={() => menuToggle()}
                            onKeyDown={() => {}}
                          >
                            <img
                              className="user__element-avatar"
                              alt={usercontent.userName}
                              src={usercontent.userAvatar}
                            />
                          </div>
                        </div>
                      ))}
                    <OutsideClickHandler
                      onOutsideClick={() => {
                        setOpenmenu(false);
                      }}
                    >
                      <div className="usermenu__toggle-menu">
                        <div className="bg-neutral-04 relative overflow-hidden flex flex-col rounded-sm overflow-hidden">
                          {/* <div className="usermenu__toggle-menu-container"> */}
                          {menuList &&
                            menuList.map((list: any) => (
                              // <a
                              //   // type="button"
                              //   key={IDHelpers.generateID()}
                              //   href={list.urlClick}
                              //   // onClick={list.handleClick}
                              //   // onKeyDown={() => {}}
                              //   className="text-body menu__element-link"
                              // >
                              //   <div className="menu__container_element">
                              //     <CcIcon
                              //       name={list.iconName}
                              //       style={{ color: 'var(--icon-help)' }}
                              //     />
                              //     <span className="ml-sm menu__element-label">
                              //       {list.labelText}
                              //     </span>
                              //   </div>
                              // </a>
                              <button
                                type="button"
                                key={IDHelpers.generateID()}
                                // href={list.urlClick}
                                onClick={(e) => {
                                  e.currentTarget.blur();
                                  list.handleClick();
                                }}
                                // onKeyDown={() => {}}
                                className="text-body menu__element-link"
                              >
                                <div className="menu__container_element">
                                  <CcIcon
                                    className={
                                      list.labelText === 'Limpiar caché' &&
                                      loadingClearCache
                                        ? 'image_rotate'
                                        : ''
                                    }
                                    name={list.iconName}
                                    style={{ color: 'var(--icon-help)' }}
                                  />
                                  <span className="ml-sm menu__element-label">
                                    {list.labelText}
                                  </span>
                                </div>
                              </button>
                            ))}
                          {/* </div> */}
                        </div>
                      </div>
                    </OutsideClickHandler>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ContainerHelp>
              <Button onClick={loginAction}>Ingresar</Button>
              <UserBlankImage src={UserBlankImageUrl} alt="user blank" />
            </ContainerHelp>
          )
        }
      </UserMenuWrapper>
    </UserMenuElement>
  );
}

// UserMenuHelp.defaultProps = {
//   // imageProfile:
//   //   'data:image/png;base64,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',
//   menu: [
//     {
//       labelText: 'Mi Perfil',
//       iconName: 'user',
//       modeClick: true,
//       // handleClick: () => {},
//       urlClick: '#'
//     },
//     {
//       labelText: 'Cerrar sesión',
//       iconName: 'log-out',
//       modeClick: true,
//       handleClick: () => {
//         const dispatch = useDispatch();
//         dispatch(signOutActions.signOut());
//       },
//       urlClick: '#'
//     }
//   ],
//   user: [
//     {
//       userName: 'UserName',
//       userAvatar:
//         'data:image/png;base64,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'
//     }
//   ]
// };

export default UserMenuHelp;
